import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { createBrowserHistory } from "history";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { routerReducer } from "react-router-redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";

import reducers from "./reducers";
import sagas from "./sagas";

// connectRouter
import { connectRouter, routerMiddleware } from "connected-react-router";

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);

let middlewares = [thunk, sagaMiddleware, routeMiddleware];
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // dev code
  middlewares = [thunk, sagaMiddleware, routeMiddleware, logger];
}

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const AuthPersistConfig = {
  key: "Auth",
  storage,
  whitelist: [
    "isDeviceRegistered",
    "device_token",
    "uuid",
    "jwt_token",
    "isLoggedIn",
    "referral_code",
  ],
};

const ConsumerPersistConfig = {
  key: "Consumer",
  storage,
  whitelist: ["becomeMerchantData", "voucherQuantity", "shownMFAlert"],
};

const AppPersistConfig = {
  key: "App",
  storage,
  whitelist: ["cart", "hideShopAlertDoNotShow"],
};

const isFirstLoad = {
  key: "IsFirstLoad",
  storage,
  whitelist: ["isFirstLoad"],
};

const locationPersistConfig = {
  key: "Location",
  storage,
  whitelist: ["storeLocation"],
};

const ProductPreference = {
  key: "ProductPref",
  storage,
  whitelist: ["productPreference"],
};

const TempStoreCart = {
  key: "TempStoreCart",
  storage,
  whitelist: ["tempStoreCart"],
};

const persistedReducer = persistReducer(
  rootPersistConfig,
  combineReducers({
    router: connectRouter(history),
    App: persistReducer(AppPersistConfig, reducers.App),
    Auth: persistReducer(AuthPersistConfig, reducers.Auth),
    Bank: reducers.Bank,
    BusinessCategory: reducers.BusinessCategory,
    Consumer: persistReducer(ConsumerPersistConfig, reducers.Consumer),
    Email: reducers.Email,
    GoogleMap: reducers.GoogleMap,
    IsFirstLoad: persistReducer(isFirstLoad, reducers.App),
    Location: persistReducer(locationPersistConfig, reducers.Location),
    Mall: reducers.Mall,
    Menu: reducers.Menu,
    Notification: reducers.Notification,
    Order: reducers.Order,
    ProductPreference: persistReducer(ProductPreference, reducers.Preference),
    Preference: reducers.Preference,
    Restaurant: reducers.Restaurant,
    Review: reducers.Review,
    TempStoreCart: persistReducer(TempStoreCart, reducers.Mall),
    Voucher: reducers.Voucher,
    Wallet: reducers.Wallet,

    routerReducer,
  })
);

const store = createStore(
  persistedReducer,
  undefined,
  compose(applyMiddleware(...middlewares))
);
sagaMiddleware.run(sagas);

const persistor = persistStore(store);

export { store, persistor, history };
